export const FETCHED_DIGGS = "FETCHED_DIGGS";
export const FETCHING_DIGGS = "FETCHING_DIGGS";
export const RECEIVED_DIGGS = "RECEIVED_DIGGS";
